export const updateList = (dados) => {
    return {
        type: 'UPDATE_LOAD_UNLOAD_LIST',
        dados,
    };
};
export const insertConfirmationMdrList = (item) => {
    return {
        type: 'INSERT_CONFIRMATION_LIST',
        item,
    };
};

export const updateConfirmationMdrList = (item) => {
    return {
        type: 'UPDATE_CONFIRMATION_LIST',
        item,
    };
};

export const removeConfirmationMdrList = (item) => {
    return {
        type: 'REMOVE_CONFIRMATION_LIST',
        item
    };
};

export const clearConfirmationMdrList = () => {
    return {
        type: 'CLEAR_CONFIRMATION_LIST',
    };
};
export const setMvm = (mvm) => {
    return {
        type: 'SET_MVM',
        mvm
    }
}

export const setShedList = (list) => {
    return {
        type: 'SET_SHED_LIST',
        list
    }
}

export const setShedConfigList = (list) => {
    return {
        type: 'SET_SHED_CONFIG_LIST',
        list
    }
}

export const updateShedConfig = (item) => {
    return {
        type: 'UPDATE_SHED_CONFIG_LIST',
        item
    }
}

export const clearAll = (list) => {
    return {
        type: 'CLEAR_ALL',
        list
    }
}

export const setRackTypeList = (list) => {
    return {
        type: 'SET_RACK_TYPE_LIST',
        list
    }
}

export const setShed = (shed, shedObj) => {
    return {
        type: 'SET_SHED',
        shed,
        shedObj
    }
}

export const setMovementType = (movementType, movementTypeObj) => {
    return {
        type: 'SET_MOVEMENT_TYPE',
        movementType,
        movementTypeObj
    }
}

export const showSupplier = () => {
    return {
        type: 'SHOW_SUPPLIER',
        showSupplierComponent: true
    };
};

export const hideSupplier = () => {
    return {
        type: 'HIDE_SUPPLIER',
        showSupplierComponent: false
    };
};
